import React, { useEffect, useState } from 'react';
import cn from 'classnames';

import Modal from '../../../common/ui/Modal';
import { formatPrice } from '../../../../utils/formatters';
import Button from '../../../common/ui/Button';
import { DATE_FORMAT } from '../../../../utils/dates';

import styles from './styles.module.scss';

const DeviceUpgradeModal = ({
  variant,
  nextChargeDate,
  isOpen,
  handleClose,
  handleSubmit,
  isLoading,
  type,
  upgradeVariant,
}) => {
  const [selectedType, setSelectedType] = useState('current');
  const title =
    type === 'current'
      ? 'Choose when to update your plan:'
      : 'Change upcoming plan';
  const formattedNextChargeDateObj = nextChargeDate
    .add(1, 'month')
    .subtract(1, 'day')
    .local()
    .format(DATE_FORMAT);
  const formattedNextChargeDate = nextChargeDate.local().format(DATE_FORMAT);
  const currentDay = getFormattedCurrentDay();
  const currentCycleEnd = nextChargeDate
    .subtract(1, 'day')
    .local()
    .format(DATE_FORMAT);
  const upgradePrice = formatPrice(upgradeVariant?.prices[0]?.unit_price);
  const buttonTitle = selectedType === 'current' ? 'Apply & Pay' : 'Apply';

  const handleVariantClick = (type) => {
    setSelectedType(type);
  };

  const handleSubmitForm = () => {
    handleSubmit(selectedType);
  };

  useEffect(() => {
    if (type === 'upcoming') {
      setSelectedType('upcoming');
    }
  }, [type, selectedType]);

  return (
    <Modal
      isOpen={isOpen}
      className={styles.upgradeModal}
      onClose={handleClose}
    >
      <h2 className={cn(styles.upgradeModalTitle)}>{title}</h2>
      <div
        className={cn(styles.upgradeModalTypes, {
          [styles.upcoming]: type === 'upcoming',
        })}
      >
        {type !== 'upcoming' && (
          <>
            <div
              className={cn(styles.upgradeModalType, {
                [styles.active]: selectedType === 'current',
              })}
              onClick={() => handleVariantClick('current')}
            >
              <span>Your card will be charged now</span>
              <h3>Current Cycle</h3>
              <p>
                {currentDay} — {currentCycleEnd}
              </p>
            </div>
          </>
        )}
        <div
          className={cn(styles.upgradeModalType, {
            [styles.active]: selectedType === 'upcoming',
          })}
          onClick={() => handleVariantClick('upcoming')}
        >
          <span>Your card will be charged on {formattedNextChargeDate}</span>
          <h3>Next Cycle</h3>
          <p>
            {formattedNextChargeDate.split(',')[0]} —{' '}
            {formattedNextChargeDateObj}
          </p>
        </div>
      </div>
      <div className={styles.upgradeModalFooter}>
        <div className={styles.upgradeModalFooterInfo}>
          <div className={styles.upgradeModalFooterInfoGb}>
            {variant?.amount?.replace('gb', '')}
            <span>GB</span>
          </div>
          <div className={styles.upgradeModalFooterInfoSeparator}></div>
          <div className={styles.upgradeModalFooterInfoPriceWrapper}>
            {selectedType === 'current' && (
              <div className={styles.upgradeModalFooterInfoPrice}>
                <p>Pay Today: </p>${upgradePrice}
              </div>
            )}
            <div className={styles.upgradeModalFooterInfoPrice}>
              <p>Starting next billing cycle: </p>${formatPrice(variant.price)}
              <span>/month</span>
            </div>
          </div>
        </div>
        <Button
          onClick={handleSubmitForm}
          className={styles.upgradeModalButton}
          isLoading={isLoading}
        >
          {buttonTitle}
        </Button>
      </div>
    </Modal>
  );

  function getFormattedCurrentDay() {
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];

    const currentDate = new Date();
    const month = months[currentDate.getMonth()];
    const day = currentDate.getDate();

    return `${month} ${day}`;
  }
};

export default DeviceUpgradeModal;
